import { render, staticRenderFns } from "./SourceVideoList.vue?vue&type=template&id=54e8c3b3&scoped=true&"
import script from "./SourceVideoList.vue?vue&type=script&lang=ts&"
export * from "./SourceVideoList.vue?vue&type=script&lang=ts&"
import style0 from "./SourceVideoList.vue?vue&type=style&index=0&id=54e8c3b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8c3b3",
  null
  
)

export default component.exports